import { render, staticRenderFns } from "./InventoriesMarketAreas.vue?vue&type=template&id=07118e98&"
import script from "./InventoriesMarketAreas.vue?vue&type=script&lang=ts&"
export * from "./InventoriesMarketAreas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports